// App Center module page-level translations
export default {
  // Common
  'pages.app.common.appId': 'App ID',
  'pages.app.common.appName': 'App Name',
  'pages.app.common.description': 'Description',
  'pages.app.common.type': 'Type',
  'pages.app.common.order': 'Sort Order',
  'pages.app.common.status': 'Status',
  'pages.app.common.operation': 'Actions',
  'pages.app.common.company': 'Company',
  'pages.app.common.department': 'Department',
  'pages.app.common.role': 'Role',
  'pages.app.common.user': 'User',
  'pages.app.common.createTime': 'Created At',
  'pages.app.common.updateTime': 'Updated At',
  'pages.app.common.creator': 'Creator',
  'pages.app.common.updater': 'Updater',
  'pages.app.common.enabled': 'Enable',
  'pages.app.common.disabled': 'Disable',
  'pages.app.common.enabledIn': 'Active',
  'pages.app.common.disabledIn': 'Inactive',
  'pages.app.common.disabledDone': 'Disabled',
  'pages.app.common.noDescription': 'No description available',
  'pages.app.common.notAvailable': 'N/A',
  'pages.app.common.other': 'Other',
  'pages.app.common.all': 'All',
  'pages.app.common.chat': 'Chat',
  'pages.app.common.search': 'Search',
  'pages.app.common.memory': 'Memory',
  'pages.app.common.agent': 'Agent',
  'pages.app.common.more': 'More',
  'pages.app.common.collapse': 'Collapse',
  'pages.app.common.searchPlaceholder': 'Please enter',
  'pages.app.common.keywordPlaceholder': 'Search keywords...',
  'pages.app.common.filterCondition': 'Filters',
  'pages.app.common.icon': 'Icon',
  'pages.app.common.total': 'Total records',
  'pages.app.common.export': 'Export',
  'pages.app.common.print': 'Print',
  'pages.app.common.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.common.exportOptionCsv': 'CSV (.csv)',
  'pages.app.common.exportOptionPdf': 'PDF (.pdf)',

  // My Apps & Management
  'pages.app.mine.title': 'My Apps',
  'pages.app.mine.unionQuery': 'Combined Search',
  'pages.app.mine.fetchListFailed': 'Failed to load app list',
  'pages.app.mine.noDescription': 'No description',
  'pages.app.mine.useUserCount': '{count} users',
  'pages.app.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.exportOptionCsv': 'CSV (.csv)',
  'pages.app.exportOptionPdf': 'PDF (.pdf)',
  'pages.app.action.edit': 'Edit',
  'pages.app.action.config': 'Configure',
  'pages.app.action.enable': 'Enable',
  'pages.app.action.disable': 'Disable',
  'pages.app.action.export': 'Export',
  'pages.app.action.create': 'Create New',
  'pages.app.mgmt.list.title': 'App Management',
  'pages.app.mgmt.list.reportTitle': 'App List',
  'pages.app.mgmt.list.reportDataTitle': 'App Data',
  'pages.app.mgmt.list.unionQuery': 'Combined Query',
  'pages.app.mgmt.list.appType': 'App Type',
  'pages.app.mgmt.list.appTypePlaceholder': 'Select or enter app type',
  'pages.app.mgmt.list.totalApps': 'Total Apps',
  'pages.app.mgmt.list.summary': 'Total {count} items',
  'pages.app.mgmt.list.exportNoData': 'No data available for export',
  'pages.app.mgmt.list.exportSuccess': 'Exported successfully',
  'pages.app.mgmt.list.exportFailed': 'Export failed',
  'pages.app.mgmt.list.toggleSuccess': 'Operation successful',
  'pages.app.mgmt.list.toggleFailed': 'Operation failed',
  'pages.app.mgmt.list.confirmTitle': 'Confirm Action',
  'pages.app.mgmt.list.confirmDisable': 'Are you sure you want to disable this app?',
  'pages.app.mgmt.list.confirmEnable': 'Are you sure you want to enable this app?',

  // Detail & Edit
  'pages.app.detail.title': 'App Details',
  'pages.app.detail.edit': 'Edit',
  'pages.app.detail.backList': 'Back to List',
  'pages.app.detail.fetchFailed': 'Failed to load app details',
  'pages.app.detail.appIcon': 'App Icon',
  'pages.app.detail.basicInfo': 'Basic Information',
  'pages.app.detail.accessControl': 'Access Control',
  'pages.app.detail.description': 'App Description',
  'pages.app.detail.company': 'Company',
  'pages.app.detail.department': 'Department',
  'pages.app.detail.role': 'Role',
  'pages.app.detail.user': 'Owner',
  'pages.app.create.title': 'Create App',
  'pages.app.edit.title': 'Edit App',

  // Form Labels & Placeholders
  'pages.app.form.appName.label': 'App Name',
  'pages.app.form.appName.placeholder': 'Enter app name',
  'pages.app.form.appName.required': 'App name is required',
  'pages.app.form.appIcon.label': 'App Icon',
  'pages.app.form.appType.label': 'App Type',
  'pages.app.form.appType.placeholder': 'Select type',
  'pages.app.form.appType.required': 'Please select a type',
  'pages.app.form.description.label': 'Description',
  'pages.app.form.description.placeholder': 'Enter app description',
  'pages.app.form.order.label': 'Sort Order',
  'pages.app.form.order.placeholder': 'Enter order number',
  'pages.app.form.order.required': 'Order number is required',
  'pages.app.form.status.label': 'Status',
  'pages.app.form.status.placeholder': 'Select status',
  'pages.app.form.status.required': 'Please select a status',
  'pages.app.form.status.enabled': 'Enabled',
  'pages.app.form.status.disabled': 'Disabled',
  'pages.app.form.company.label': 'Company',
  'pages.app.form.company.placeholder': 'Select company',
  'pages.app.form.department.label': 'Department',
  'pages.app.form.department.placeholder': 'Select department',
  'pages.app.form.role.label': 'Role',
  'pages.app.form.role.placeholder': 'Select role',
  'pages.app.form.user.label': 'User',
  'pages.app.form.user.placeholder': 'Select user',
  'pages.app.form.keywordPlaceholder': 'Enter keywords',

  // Creation Methods & Errors
  'pages.app.create.method.label': 'Creation Method',
  'pages.app.create.method.required': 'Please select a creation method',
  'pages.app.create.method.blank': 'Create from Scratch',
  'pages.app.create.method.template': 'Use Template',
  'pages.app.create.method.import': 'Import JSON File',
  'pages.app.create.agentType.label': 'Agent Type',
  'pages.app.create.agentType.required': 'Please select an agent type',
  'pages.app.create.agentType.flow': 'Agent Flow',
  'pages.app.create.agentType.pipeline': 'Ingestion Pipeline',
  'pages.app.create.template.label': 'Select Template',
  'pages.app.create.template.placeholder': 'Choose a template',
  'pages.app.create.template.required': 'Please select a template',
  'pages.app.create.dsl.label': 'DSL File',
  'pages.app.create.dsl.selectFile': 'Select JSON File',
  'pages.app.create.dsl.selected': 'Selected: {name}',
  'pages.app.create.dsl.empty': 'DSL file cannot be empty',
  'pages.app.create.dsl.invalidGraph': 'DSL file is missing valid node data (graph.nodes)',
  'pages.app.create.dsl.invalidJson': 'Invalid JSON format',
  'pages.app.create.error.selectTemplate': 'Please select a template',
  'pages.app.create.error.templateNotFound': 'Template data not found, please try again',
  'pages.app.create.error.selectDslFile': 'Please select a DSL JSON file',
  'pages.app.create.error.selectCreateMethod': 'Please select a creation method',
  'pages.app.create.error.appTypeInvalid': 'Invalid app type',
  'pages.app.create.error.createFailed': 'Failed to create app',
  'pages.app.create.error.createAgentFailed': 'Failed to create agent',
  'pages.app.create.error.fetchGlobalConfigFailed': 'Failed to load global configuration',
  'pages.app.create.success': 'Created successfully',
  'pages.app.edit.error.fetchFailed': 'Failed to load app details',
  'pages.app.edit.error.updateFailed': 'Failed to update app',
  'pages.app.edit.error.updateAgentFailed': 'Failed to update agent',
  'pages.app.edit.success': 'Updated successfully',

  // Analysis & Dashboard
  'pages.app.analysis.company': 'Company',
  'pages.app.analysis.date': 'Date',
  'pages.app.analysis.appName': 'App Name',
  'pages.app.analysis.userCount': 'Active Users',
  'pages.app.analysis.tokenUsed': 'Tokens Consumed',
  'pages.app.analysis.appCount': 'Number of Apps',
  'pages.app.analysis.appFilterLabel': 'App',
  'pages.app.analysis.appFilterPlaceholder': 'Select app',
  'pages.app.analysis.tab.usage': 'User Traffic',
  'pages.app.analysis.tab.token': 'Token Usage',
  'pages.app.analysis.tab.count': 'App Stats',
  'pages.app.analysis.rank.app': 'App',
  'pages.app.analysis.rank.company': 'Company',
  'pages.app.analysis.rank.user': 'User',
  'pages.app.analysis.quick.today': 'Today',
  'pages.app.analysis.quick.week': 'This Week',
  'pages.app.analysis.quick.month': 'This Month',
  'pages.app.analysis.quick.year': 'This Year',
  'pages.app.analysis.query.hourly': 'Hourly',
  'pages.app.analysis.query.daily': 'Daily',
  'pages.app.analysis.query.weekly': 'Weekly',
  'pages.app.analysis.query.monthly': 'Monthly',
  'pages.app.analysis.chart.usageTrend': 'User Trend',
  'pages.app.analysis.chart.tokenTrend': 'Token Consumption Trend',
  'pages.app.analysis.chart.countTrend': 'App Growth Trend',
  'pages.app.analysis.rank.usage': 'User Ranking',
  'pages.app.analysis.rank.token': 'Token Consumption Ranking',
  'pages.app.analysis.metric.usage': 'Active Users',
  'pages.app.analysis.metric.token': 'Token Usage',
  'pages.app.analysis.metric.count': 'Number of Apps',

  // App Config
  'pages.app.config.updateSuccess': 'Updated successfully',
  'pages.app.config.updateFailed': 'Update failed',
  'pages.app.config.deleteSuccess': 'Deleted successfully',
  'pages.app.config.deleteFailed': 'Delete failed',
  'pages.app.config.addSuccess': 'Added successfully',
  'pages.app.config.addFailed': 'Add failed',
  'pages.app.config.saveSuccess': 'Settings saved',
  'pages.app.config.saveFailed': 'Save failed',
  'pages.app.config.defaultTitle': 'Set Default Model',
  'pages.app.config.subtitle': 'Please complete these settings before starting',
  'pages.app.config.selectModelPlaceholder': 'Select a model',
  'pages.app.config.addedModelsTitle': 'Configured Models',
  'pages.app.config.hideModels': 'Hide',
  'pages.app.config.showMoreModels': 'Show More',
  'pages.app.config.addModelHint': 'Add models (OpenAI, Gemini...)',
  'pages.app.config.addModel': 'Add Model',
  'pages.app.config.providerLabel': 'Provider',
  'pages.app.config.providerRequired': 'Please select a provider',
  'pages.app.config.apiKeyRequired': 'API Key is required',
  'pages.app.config.editTitle': 'Edit {name} Configuration',

  // Search/RAG Config
  'pages.app.searchConfig.name.label': 'Name',
  'pages.app.searchConfig.name.placeholder': 'Enter name',
  'pages.app.searchConfig.name.required': 'Name is required',
  'pages.app.searchConfig.avatar': 'Avatar',
  'pages.app.searchConfig.upload': 'Upload',
  'pages.app.searchConfig.uploadTip': 'Max file size: 4MB',
  'pages.app.searchConfig.description.label': 'Description',
  'pages.app.searchConfig.description.placeholder': 'Enter description',
  'pages.app.searchConfig.knowledgeBase.label': 'Knowledge Base',
  'pages.app.searchConfig.knowledgeBase.placeholder': 'Select...',
  'pages.app.searchConfig.knowledgeBase.required': 'Please select a knowledge base',
  'pages.app.searchConfig.knowledgeBase.sample2': 'Sample Knowledge Base 2',
  'pages.app.searchConfig.metadata.label': 'Metadata',
  'pages.app.searchConfig.metadata.tooltip': 'Select metadata fields for retrieval reference',
  'pages.app.searchConfig.metadata.auto': 'Auto',
  'pages.app.searchConfig.similarityThreshold.label': 'Similarity Threshold',
  'pages.app.searchConfig.similarityThreshold.tooltip': 'Minimum similarity score for document chunks',
  'pages.app.searchConfig.vectorWeight.label': 'Vector Weight',
  'pages.app.searchConfig.vectorWeight.tooltip': 'Balance between vector and keyword search',
  'pages.app.searchConfig.rerankModel': 'Rerank Model',
  'pages.app.searchConfig.aiSummary': 'AI Summary',
  'pages.app.searchConfig.enableRelatedSearch': 'Enable Related Search',
  'pages.app.searchConfig.showMindMap': 'Show Mind Map',

  // Memory Config
  'pages.app.memoryConfig.memoryType.label': 'Memory Type',
  'pages.app.memoryConfig.memoryType.tooltip': 'Select how the agent remembers interactions',
  'pages.app.memoryConfig.memoryType.placeholder': 'Select type',
  'pages.app.memoryConfig.memoryType.required': 'Memory type is required',
  'pages.app.memoryConfig.memoryType.raw': 'Raw',
  'pages.app.memoryConfig.memoryType.semantic': 'Semantic',
  'pages.app.memoryConfig.memoryType.episodic': 'Episodic',
  'pages.app.memoryConfig.memoryType.procedural': 'Procedural',
  'pages.app.memoryConfig.embeddingModel.label': 'Embedding Model',
  'pages.app.memoryConfig.embeddingModel.tooltip': 'Model used for text vectorization',
  'pages.app.memoryConfig.embeddingModel.placeholder': 'Select model',
  'pages.app.memoryConfig.embeddingModel.required': 'Embedding model is required',
  'pages.app.memoryConfig.llm.label': 'Large Language Model',
  'pages.app.memoryConfig.llm.tooltip': 'Primary model for processing tasks',
  'pages.app.memoryConfig.llm.placeholder': 'Select LLM',
  'pages.app.memoryConfig.llm.required': 'LLM is required',

  // Chat Config
  'pages.app.chatConfig.title': 'Chat Settings',
  'pages.app.chatConfig.avatar': 'Assistant Avatar',
  'pages.app.chatConfig.upload': 'Upload',
  'pages.app.chatConfig.uploadTip': 'Max file size: 4MB',
  'pages.app.chatConfig.uploadTooLarge': 'File must be smaller than 4MB!',
  'pages.app.chatConfig.emptyReply.label': 'Fallback Response',
  'pages.app.chatConfig.emptyReply.tooltip': 'Message displayed when the system cannot find an answer',
  'pages.app.chatConfig.emptyReply.placeholder': 'Enter fallback message',
  'pages.app.chatConfig.prologue.label': 'Greeting Message',
  'pages.app.chatConfig.prologue.tooltip': 'Welcome message shown at the start of a chat',
  'pages.app.chatConfig.prologue.placeholder': 'Enter greeting',
  'pages.app.chatConfig.showCitations': 'Show Citations',
  'pages.app.chatConfig.keywordAnalysis': 'Keyword Analysis',
  'pages.app.chatConfig.textToSpeech': 'Text-to-Speech',
  'pages.app.chatConfig.directoryEnhancement': 'Directory Enhancement',
  'pages.app.chatConfig.showCitations.tooltip': 'Display referenced document sources in answers',
  'pages.app.chatConfig.keywordAnalysis.tooltip': 'Extract and analyze keywords from user queries',
  'pages.app.chatConfig.textToSpeech.tooltip': 'Convert text responses into audio',
  'pages.app.chatConfig.directoryEnhancement.tooltip': 'Optimize retrieval using document structure',
  'pages.app.chatConfig.knowledgeBase.label': 'Knowledge Base',
  'pages.app.chatConfig.knowledgeBase.tooltip': 'Link this assistant to a specific knowledge base',
  'pages.app.chatConfig.knowledgeBase.placeholder': 'Select...',
  'pages.app.chatConfig.knowledgeBase.sample1': 'Sample Knowledge Base 1',
  'pages.app.chatConfig.knowledgeBase.sample2': 'Sample Knowledge Base 2',
  'pages.app.chatConfig.systemPrompt.label': 'System Prompt',
  'pages.app.chatConfig.systemPrompt.placeholder': 'Define the assistant\'s persona and rules',
  'pages.app.chatConfig.similarityThreshold.label': 'Similarity Threshold',
  'pages.app.chatConfig.similarityThreshold.tooltip': 'Minimum relevance score for retrieved chunks',
  'pages.app.chatConfig.vectorWeight.label': 'Vector Weight',
  'pages.app.chatConfig.vectorWeight.tooltip': 'Adjust the balance between vector and full-text search',
  'pages.app.chatConfig.multiRoundOptimization.label': 'Multi-turn Optimization',
  'pages.app.chatConfig.multiRoundOptimization.tooltip': 'Analyzes history to improve context understanding in ongoing chats',
  'pages.app.chatConfig.useKnowledgeGraph.label': 'Use Knowledge Graph',
  'pages.app.chatConfig.useKnowledgeGraph.tooltip': 'Leverage structured data for deeper reasoning',
  'pages.app.chatConfig.reasoning.label': 'Inference',
  'pages.app.chatConfig.reasoning.tooltip': 'Enable complex reasoning using the knowledge graph',
  'pages.app.chatConfig.rerankModel.label': 'Rerank Model',
  'pages.app.chatConfig.rerankModel.tooltip': 'Model used to re-prioritize search results',
  'pages.app.chatConfig.crossLanguageSearch.label': 'Cross-language Search',
  'pages.app.chatConfig.crossLanguageSearch.tooltip': 'Allow searching across different languages',
  'pages.app.chatConfig.crossLanguageSearch.disabled': 'Disabled',
  'pages.app.chatConfig.crossLanguageSearch.enabled': 'Enabled',
  'pages.app.chatConfig.selectPlaceholder': 'Select...',
  'pages.app.chatConfig.topN.label': 'Top N',
  'pages.app.chatConfig.topN.tooltip': 'Number of most relevant chunks to retrieve',
  'pages.app.chatConfig.variables.label': 'Variables',
  'pages.app.chatConfig.variables.tooltip': 'Dynamic variables that can be used in prompts',
  'pages.app.chatConfig.variables.delete': 'Delete',
  'pages.app.chatConfig.variables.keyword': 'Key',
  'pages.app.chatConfig.variables.keywordPlaceholder': 'Enter key',
  'pages.app.chatConfig.variables.optional': 'Optional',
  'pages.app.chatConfig.model.label': 'Model',
  'pages.app.chatConfig.model.tooltip': 'The AI model driving the conversation',
  'pages.app.chatConfig.model.placeholder': 'Select model',
  'pages.app.chatConfig.model.saveSuccess': 'Model saved successfully',
  'pages.app.chatConfig.tavily.label': 'Tavily API Key',
  'pages.app.chatConfig.tavily.tooltip': 'Key for real-time web search enhancement',
  'pages.app.chatConfig.tavily.placeholder': 'Enter your Tavily API Key',
  'pages.app.chatConfig.tavily.howToGet': 'How to get it?',

  // LLM Parameters
  'pages.app.chatConfig.temperature.label': 'Temperature',
  'pages.app.chatConfig.temperature.tooltip': 'Controls randomness: Lower is more focused, higher is more creative',
  'pages.app.chatConfig.topP.label': 'Top P',
  'pages.app.chatConfig.topP.tooltip': 'Nucleus sampling threshold',
  'pages.app.chatConfig.presencePenalty.label': 'Presence Penalty',
  'pages.app.chatConfig.presencePenalty.tooltip': 'Encourages the model to talk about new topics',
  'pages.app.chatConfig.frequencyPenalty.label': 'Frequency Penalty',
  'pages.app.chatConfig.frequencyPenalty.tooltip': 'Reduces the likelihood of repeating the same lines',
  'pages.app.chatConfig.maxTokens.label': 'Max Tokens',
  'pages.app.chatConfig.maxTokens.tooltip': 'Maximum length of the model output',
  'pages.app.chatConfig.creativity.label': 'Creativity Level',
  'pages.app.chatConfig.creativity.precise': 'Precise',
  'pages.app.chatConfig.creativity.balanced': 'Balanced',
  'pages.app.chatConfig.creativity.creative': 'Creative',
};
